
document.addEventListener("DOMContentLoaded", function () {
  // Select all .fa-cat-name-div (both top-level and subcategory)
  document.querySelectorAll('.fa-cat-name-div').forEach(function (catDiv, index) {
    var subCatDiv = catDiv.nextElementSibling;
    var iconPlus = catDiv.querySelector('.icon-plus');
    var iconMinus = catDiv.querySelector('.icon-minus');

    // Only continue if there's a submenu right after it
    if (!subCatDiv || !subCatDiv.classList.contains('wa-sub-cats-name')) return;

    // Add click handler to the .fa-cat-name-div
    catDiv.addEventListener('click', function (e) {
      // Allow link navigation
      if (e.target.closest('a')) return;

      e.preventDefault();

      var isVisible = subCatDiv.style.display === 'block' || subCatDiv.style.display === 'flex';
      var isLastMenu = subCatDiv.querySelectorAll('.fa-cat-name-div').length === 0;

      subCatDiv.style.display = isVisible ? 'none' : (isLastMenu ? 'flex' : 'block');

      if (iconPlus && iconMinus) {
        iconPlus.style.display = isVisible ? 'inline' : 'none';
        iconMinus.style.display = isVisible ? 'none' : 'inline';
      }
    });

    // Optional: open the very first top-level item by default
    if (index === 0 && catDiv.closest('.fa-cat-wrapper')) {
      var isLastMenu = subCatDiv.querySelectorAll('.fa-cat-name-div').length === 0;
      subCatDiv.style.display = isLastMenu ? 'flex' : 'block';
      if (iconPlus && iconMinus) {
        iconPlus.style.display = 'none';
        iconMinus.style.display = 'inline';
      }
    }
  });
});








/*=============================================COLLECTION SLIDER============================================================*/
$('.fa-logo-slider-row').owlCarousel({
    loop:true,
    margin:10,
    nav:false,
    dots: false,
    responsive:{
      0:{
            items:2,
        },
        420:{
            items:2,
        },
        570:{
            items:3,
        },
        820:{
            items:4
        },
        1150:{
            items:6
        }
    }
})
/*==============================================FAQ============================================================*/
document.querySelectorAll('.fa-accordian-question-flex').forEach(function(question) {
  question.addEventListener('click', function() {
    // Find the parent .fa-accordian-question
    const parent = question.closest('.fa-accordian-question');
    
    // Find the .fa-accordian-answer within the parent
    const answer = parent.querySelector('.fa-accordian-answer');
    
    // Check if the answer is currently visible or hidden
    if (answer.style.display === 'none' || answer.style.display === '') {
      // Show the answer
      answer.style.display = 'block'; // Make it visible
      setTimeout(() => { // Delay to allow display to be applied
        answer.style.opacity = '1'; // Fade in
        answer.style.maxHeight = '100% '; // Expand the content
      }, 10); // Small delay for browser to reflow after setting display: block
      parent.classList.add('open'); // Add the 'open' class to rotate the arrow
    } else {
      // Add delay before starting opacity and height collapse
      setTimeout(() => {
        // Fade out and collapse content
        answer.style.opacity = '0'; // Fade out
        answer.style.maxHeight = '0px'; // Collapse content to height 0
      }, 10); // Small delay for opacity and height transition

      // Delay the setting of display: none until after transition completes
      setTimeout(() => {
        answer.style.display = 'none'; // Remove the content from flow after transition
      }, 300); // Delay to match transition time (300ms)
      
      parent.classList.remove('open'); // Remove the 'open' class to reset the rotation
    }
  });
});

/*=============================================COMMENTS============================================================*/
$('.fa-comment-row').owlCarousel({
    loop:true,
    margin:10,
    nav:true,
    dots: false,
    responsive:{
        0:{
            items:1,
        },
        560:{
            items:2,
        },
        900:{
            items:3
        },
        1230:{
            items:4
        }
    }
})
/*=============================================COLLECTION SLIDER============================================================*/
$('.fa-product-carousel').owlCarousel({
    loop:false,
    margin:0,
    nav:false,
    dots: false,
    responsive:{
        0:{
            items:2,
        },
        520:{
            items:3,
        },
        850:{
            items:3.5,
        },
        1070:{
            items:3.5
        },
        1320:{
            items:4.5
        }
    }
})
/*================================================Product Card Slider==========================================================*/
$('.fa-variant-slider').each(function(){
  $(this).owlCarousel({
    loop: false,
    margin: 10,
    nav: true,
    dots: false,
    responsive: {
      0: { 
             items: 4,
             margin: 5
           },
      990: { 
            items: 3,
            margin: 5
            },
      1320: { items: 4 }
    }
  });
});

// document.querySelectorAll('.card-wrapper').forEach(function (element) {
//   let timer;

//   element.addEventListener('mouseenter', function () {
//     if (window.innerWidth >= 750) {
//       timer = setTimeout(() => {
//         const variantsDiv = this.querySelector('.fa-variants-div');
//         if (variantsDiv) {
//           variantsDiv.style.display = 'block';
//         }
//       }, 300);
//     }
//   });

//   element.addEventListener('mouseleave', function () {
//     clearTimeout(timer);
//     const variantsDiv = this.querySelector('.fa-variants-div');
//     if (variantsDiv) {
//       variantsDiv.style.display = 'none';
//     }
//   });
// });

